import { useEffect } from 'react'

export default function useTitle(title?: string) {
  useEffect(() => {
    const t = title ?? 'Journey Planner'

    document.title = t
  }, [title])
}
